// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel > .panel-heading {
    background-image: none;
    background-color:#004F87;
    color: white;
    text-align: center;
}

.panel {
  overflow: hidden;
}

.goRigth{
  float: right;
  margin-bottom: 2px;
  margin-right: 2px;
}

.actionButtons {
    text-align: center;
}

.panel > .panel-heading > .panel-body {
  padding: 30px;
}

ol { padding-left: 1.8em; }

.imgPerson {
  margin-top: 60px;
}

.loader,
.loader:before,
.loader:after {
  background: #ffffff;
  animation: load1 1s infinite ease-in-out;
  width: 1em;
  height: 4em;
}
.loader {
  color: #004F87;
  text-indent: -9999em;
  margin: 88px auto;
  position: relative;
  font-size: 11px;
  transform: translateZ(0);
  animation-delay: -0.16s;
}
.loader:before,
.loader:after {
  position: absolute;
  top: 0;
  content: '';
}
.loader:before {
  left: -1.5em;
  animation-delay: -0.32s;
}
.loader:after {
  left: 1.5em;
}
@keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}


.card {
background: white;
padding: 60px;
border-radius: 4px;
box-shadow: 0 2px 3px #C8D0D8;
display: inline-block;
margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/verificacion/verificacion.component.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA,KAAK,mBAAmB,EAAE;;AAE1B;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EAEnB,wCAAwC;EACxC,UAAU;EACV,WAAW;AACb;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EAGf,wBAAwB;EAExB,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE,YAAY;EAEZ,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AAaA;EACE;;;IAGE,eAAe;IACf,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;;;AAGA;AACA,iBAAiB;AACjB,aAAa;AACb,kBAAkB;AAClB,6BAA6B;AAC7B,qBAAqB;AACrB,cAAc;AACd","sourcesContent":[".panel > .panel-heading {\r\n    background-image: none;\r\n    background-color:#004F87;\r\n    color: white;\r\n    text-align: center;\r\n}\r\n\r\n.panel {\r\n  overflow: hidden;\r\n}\r\n\r\n.goRigth{\r\n  float: right;\r\n  margin-bottom: 2px;\r\n  margin-right: 2px;\r\n}\r\n\r\n.actionButtons {\r\n    text-align: center;\r\n}\r\n\r\n.panel > .panel-heading > .panel-body {\r\n  padding: 30px;\r\n}\r\n\r\nol { padding-left: 1.8em; }\r\n\r\n.imgPerson {\r\n  margin-top: 60px;\r\n}\r\n\r\n.loader,\r\n.loader:before,\r\n.loader:after {\r\n  background: #ffffff;\r\n  -webkit-animation: load1 1s infinite ease-in-out;\r\n  animation: load1 1s infinite ease-in-out;\r\n  width: 1em;\r\n  height: 4em;\r\n}\r\n.loader {\r\n  color: #004F87;\r\n  text-indent: -9999em;\r\n  margin: 88px auto;\r\n  position: relative;\r\n  font-size: 11px;\r\n  -webkit-transform: translateZ(0);\r\n  -ms-transform: translateZ(0);\r\n  transform: translateZ(0);\r\n  -webkit-animation-delay: -0.16s;\r\n  animation-delay: -0.16s;\r\n}\r\n.loader:before,\r\n.loader:after {\r\n  position: absolute;\r\n  top: 0;\r\n  content: '';\r\n}\r\n.loader:before {\r\n  left: -1.5em;\r\n  -webkit-animation-delay: -0.32s;\r\n  animation-delay: -0.32s;\r\n}\r\n.loader:after {\r\n  left: 1.5em;\r\n}\r\n@-webkit-keyframes load1 {\r\n  0%,\r\n  80%,\r\n  100% {\r\n    box-shadow: 0 0;\r\n    height: 4em;\r\n  }\r\n  40% {\r\n    box-shadow: 0 -2em;\r\n    height: 5em;\r\n  }\r\n}\r\n@keyframes load1 {\r\n  0%,\r\n  80%,\r\n  100% {\r\n    box-shadow: 0 0;\r\n    height: 4em;\r\n  }\r\n  40% {\r\n    box-shadow: 0 -2em;\r\n    height: 5em;\r\n  }\r\n}\r\n\r\n\r\n.card {\r\nbackground: white;\r\npadding: 60px;\r\nborder-radius: 4px;\r\nbox-shadow: 0 2px 3px #C8D0D8;\r\ndisplay: inline-block;\r\nmargin: 0 auto;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
